import Env from './Env'
import { AuthenticationFlow } from './services'

const yamadumiAuth = new AuthenticationFlow(
  Env.OIDC_CLIENT_ID,
  Env.OIDC_SERVICE_URI,
  {
    authenticationRedirectUri: `${window.location.origin}/${Env.OIDC_LOGIN_REDIRECT_PAGE}`,
    logoutRedirectUri: `${Env.OIDC_SERVICE_URI}/${Env.OIDC_LOGOUT_REDIRECT_PAGE}`
  }
)
export default yamadumiAuth
